import { QueryClient } from '@tanstack/react-query';
import { APIError } from './api-client';

/**
 * Single QueryClient instance for the app. Default cache: 30s staleTime
 * (fresh enough that quick re-navigation doesn't trigger refetch storms)
 * and 5min gcTime (lets a route round-trip stay warm).
 *
 * Retries: never on 4xx (caller errors), once on 5xx (transient).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof APIError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

/**
 * Cache-key prefix shared with the current org. Use as the first element of
 * every org-scoped query key so a logout / org switch can `invalidateQueries`
 * the whole tree at once.
 */
export const ORG_SCOPE = 'org-scope';
